import React from 'react';
import styled from '@emotion/styled';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  progress: {
    margin: theme.spacing(2),
  },
}));

const Spinner = () => {
  const classes = useStyles();

  return (
    <Container>
      <CircularProgress className={classes.progress} color="secondary" />
    </Container>
  );
};

export default Spinner;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  }
`;
